export default __webpack_public_path__ + "static/media/tasks-sidebar-icon.7f64b410.svg";